import { defineMessages } from 'react-intl'

export default defineMessages({
  fillDetailsTitle: {
    id: 'containers.CustomerOrderUpsertPage.containers.InsertPage.fillDetailsTitle',
    defaultMessage: 'Fill out the details',
  },
  fillDetailsBody: {
    id: 'containers.CustomerOrderUpsertPage.containers.InsertPage.fillDetailsBody',
    defaultMessage: 'Make sure to fill our all relevant data.',
  },
})